import { css } from "@emotion/react";
import styled from "@emotion/styled";

import ExternalLink from "metabase/common/components/ExternalLink";
import Link from "metabase/common/components/Link";
import Card from "metabase/components/Card";
import { Icon } from "metabase/ui";

export const BillingInfoCard = styled(Card)`
  margin-top: 1rem;
`;

export const BillingInfoRowContainer = styled.div<{ extraPadding?: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: ${({ extraPadding }) => (extraPadding ? `1.5rem` : `0.5rem`)} 1rem;
  align-items: center;

  &:not(:last-child) {
    border-bottom: 1px solid var(--mb-color-bg-medium);
  }
`;

const linkStyles = css`
  display: inline-flex;
  align-items: center;
  color: var(--mb-color-brand);
`;

export const BillingInternalLink = styled(Link)(linkStyles);

export const BillingExternalLink = styled(ExternalLink)(linkStyles);

export const BillingExternalLinkIcon = styled(Icon)`
  margin-left: 0.25rem;
`;

export const StoreButtonLink = styled(ExternalLink)`
  display: inline-flex;
  background-color: var(--mb-color-brand);
  color: var(--mb-color-text-white);
  align-items: center;
  font-weight: bold;
  padding: 0.75rem 1rem;
  margin-top: 1rem;
  border-radius: 6px;

  &:hover {
    opacity: 0.88;
    transition: all 200ms linear;
  }
`;
